import { useCustomUpdateWorksheetProductMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";
import getLocalString from "constants/Localization";

export default function useUpdateWorksheetProduct() {
  const [mutation, { loading, data, error }] = useCustomUpdateWorksheetProductMutation({
    refetchQueries: ["customGetWorksheetProducts", "customGetWorksheetProduct"],
  });
  const [updateWorksheetProduct, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "updateWorksheetProduct",
    },
    {
      successMessage: getLocalString("worksheet.update-product-success"),
      failureMessage: getLocalString("worksheet.update-product-failure"),
      showValidationErrors: true,
    }
  );

  return [updateWorksheetProduct, context] as const;
}
